import { Button, Dropdown } from "react-bootstrap";
import "./vendorprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import duplicatePlusIcon from "../../assets/images/duplicate-plus-icon.svg";
import { ReactSVG } from "react-svg";
import { Vendor } from "../../redux/vendor/vendorSlice";
import { MouseEventHandler } from "react";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../utils/permissionUtils";

interface VendorProfileHeaderProps {
  selectedVendorData: Vendor;
  updateStatus: any;
  toggleModal: MouseEventHandler<HTMLElement>;
  duplicateVendor: any;
}

const VendorProfileHeader = ({
  selectedVendorData,
  updateStatus,
  toggleModal,
  duplicateVendor,
}: VendorProfileHeaderProps) => {

  const isPermitted = useModulePermissions(PermissionModule.VENDER_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_VENDOR_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_VENDOR_MASTER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_VENDOR_MASTER);
  const isStatusChangePermitted = isPermitted(PermissionIdentifier.INACTIVE_VENDOR_MASTER);

  return (
    <div className="user-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedVendorData.name}</h2>
        <div
          className={`status-box 
          ${selectedVendorData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          {selectedVendorData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-vendor">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        {(isDeletePermitted || isStatusChangePermitted || isDuplicatePermitted) && (
          <Dropdown>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {isDeletePermitted && selectedVendorData?.name?.toLowerCase() !== "mckesson" && (
                <Dropdown.Item onClick={toggleModal}>
                  <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                  Delete
                </Dropdown.Item>
              )}
              {isStatusChangePermitted && (
                <Dropdown.Item onClick={() => updateStatus()}>
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={deactivateicon}
                  />
                  {selectedVendorData.isActive ? "Deactivate" : "Activate"}
                </Dropdown.Item>
              )}
              {isDuplicatePermitted && (
                <Dropdown.Item onClick={duplicateVendor}>
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={duplicatePlusIcon}
                  />
                  Duplicate
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default VendorProfileHeader;
